import { gql } from '@apollo/client'
import { mutate, query } from 'shared/helpers/graphql'

export async function getRoomClassifications() {
  return query(gql`
    query Room_classifications {
      room_classifications {
        id
        classification_name
      }
    }
  `)
}

export async function upsertPackageRoomClassification(payload) {
  return mutate(
    {
      packages: [
        {
          id: payload.package_id,
          display_name: payload.display_name,
          package_room_classifications: [
            {
              room_classification_id: payload.room_classification_id,
            },
          ],
        },
      ],
    },
    gql`
      mutation Upsert_packages($packages: [packages_input]) {
        upsert_packages(packages: $packages) {
          id
        }
      }
    `,
  )
}

export async function upsertRoomClassificationPackageCategories(payload) {
  return mutate(
    {
      roomClassifications: [
        {
          id: payload.room_classification_id,
          room_classification_packages: [
            {
              categories: payload.categories,
              package_id: payload.package_id,
            },
          ],
        },
      ],
    },
    gql`
      mutation Upsert_room_classifications($roomClassifications: [room_classifications_input]) {
        upsert_room_classifications(room_classifications: $roomClassifications) {
          id
        }
      }
    `,
  )
}
